const NawyNowSortIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M21 6.96289C21.4652 6.96289 21.8496 7.34727 21.8496 7.8125C21.8496 8.27773 21.4652 8.66211 21 8.66211H3C2.53477 8.66211 2.15039 8.27773 2.15039 7.8125C2.15039 7.34727 2.53477 6.96289 3 6.96289H21Z"
        fill="#015C9A"
        stroke="#015C9A"
        stroke-width="0.2"
      />
      <path
        d="M18 11.9629C18.4652 11.9629 18.8496 12.3473 18.8496 12.8125C18.8496 13.2777 18.4652 13.6621 18 13.6621H6C5.53477 13.6621 5.15039 13.2777 5.15039 12.8125C5.15039 12.3473 5.53477 11.9629 6 11.9629H18Z"
        fill="#015C9A"
        stroke="#015C9A"
        stroke-width="0.2"
      />
      <path
        d="M14 16.9629C14.4652 16.9629 14.8496 17.3473 14.8496 17.8125C14.8496 18.2777 14.4652 18.6621 14 18.6621H10C9.53477 18.6621 9.15039 18.2777 9.15039 17.8125C9.15039 17.3473 9.53477 16.9629 10 16.9629H14Z"
        fill="#015C9A"
        stroke="#015C9A"
        stroke-width="0.2"
      />
    </svg>
  );
};
export default NawyNowSortIcon;
